import React, { Component } from 'react';
import { Col, Row, Button, ButtonGroup } from 'react-bootstrap';
import './productCard.scss';
import NexusLogo from '../../assets/img/logo/Nexus.png'
import KeelsDealsLogo from '../../assets/img/logo/KeellsDeals.png'
import { toast } from 'react-toastify';
import { JKOAMerchantTypes, shoppingMethod } from '../../utility/enums';

/*-- Import required components --*/
import { toCurrency, IncrementItem, DecrementItem } from '../../utility/commonFunctions';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { showProductMagnifier } from '../../redux/actions/productMagnifierActions';
import { showAgeGate, resetAgeGate } from '../../redux/actions/ageGateActions';
import { showMessageBox, resetMessageBox } from '../../redux/actions/messageBoxActions';
import { jkoaPurchaseYes, jkoaPurchaseNo } from '../../redux/actions/jkoaPurchaseAction';
import { showNexusReminderNotificationBox, resetNexusReminderNotificationBox } from '../../redux/actions/V2_0/nexusReminderNotificationBoxActions';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        itemCart: state.itemCart,
        promotionItems: state.promotionItems,
        userDetails: state.userDetails,
        ageVerification: state.ageVerification,
        systemConfiguration: state.webDataCollection.systemConfiguration,
        shoppingPreference: state.shoppingPreference,
        jkoaPurchase: state.jkoaPurchase,
        webDataCollection: state.webDataCollection,
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    showProductMagnifier,
    showAgeGate,
    resetAgeGate,
    showMessageBox,
    resetMessageBox,
    jkoaPurchaseYes,
    jkoaPurchaseNo,
    showNexusReminderNotificationBox,
    resetNexusReminderNotificationBox,
};

class ProductCard extends Component {
    state = {}

    incrementProduct(product) {
        IncrementItem(product, () => { })
    };

    addProduct(product) {
        //Nexus Reminder Popup
        const itemPromotion = this.props.promotionItems.find(x => x.itemID === product.itemID && x.promotionSubTypeID !== 9);
        if (itemPromotion != undefined && itemPromotion.otherPromotionTypeID === 2) {
            if (!this.props.userDetails.isNexus) {
                let nexusReminderNotificationBox = {
                    show: true,
                    title: "You're missing out!",
                    content: "You're missing out on an " + Math.floor(itemPromotion.discountPercentage) + "% discount on this item because you are not a Nexus member yet. If you wish to register, click here.",
                    isConfirmation: false,
                    callBackFunction: (response) => {
                        if (response) {
                            window.location.href = "/nexusRegistration"
                        }
                    }
                }
                this.props.showNexusReminderNotificationBox(nexusReminderNotificationBox)
            }
        }
        //change to proper value
        if (product.checkAge) {
            //is of legal age
            if (this.props.ageVerification.isLegalAge && this.props.ageVerification.attemptedVerification) {
                IncrementItem(product, () => { })
                this.showNotificationBox()
            } else if (!this.props.ageVerification.isLegalAge && this.props.ageVerification.attemptedVerification) {
                this.showAgeFail();
            } else if (!this.props.ageVerification.attemptedVerification) {
                let ageGate = {
                    show: true,
                    isPage: false,
                    callBackFunction: (response) => {
                        if (response) {
                            this.props.resetAgeGate().then(() => { IncrementItem(product, () => { }) })
                            this.showNotificationBox()
                        } else {
                            this.props.resetAgeGate()
                            this.showAgeFail();
                        }
                    }
                }
                this.props.showAgeGate(ageGate);
            }
        } else {
            let curretIsJKOA = Object.values(JKOAMerchantTypes).includes(product.merchantID);
            if (this.props.itemCart.length > 0) {
                if ((this.props.jkoaPurchase && !curretIsJKOA) || (!this.props.jkoaPurchase && curretIsJKOA)) {
                    this.showJKOAItemFail();
                } else {
                    curretIsJKOA ? this.props.jkoaPurchaseYes() : this.props.jkoaPurchaseNo();
                    IncrementItem(product, () => { })
                    this.showNotificationBox()
                }
            } else {
                if (curretIsJKOA) {
                    if (this.props.shoppingPreference.shoppingMethod === shoppingMethod.delivery ||
                        //this is checking in the showcase. In the showcase, no any shipping method were selected
                        this.props.shoppingPreference.shoppingMethod === "") {
                        this.props.jkoaPurchaseYes();
                        IncrementItem(product, () => { })
                        this.showNotificationBox()
                    } else {
                        this.showJKOAShippingMethodFail();
                    }
                } else {
                    IncrementItem(product, () => { })
                    this.showNotificationBox()
                }
            }
            // IncrementItem(product, () => { })
            // this.showNotificationBox()
        }
    }

    showJKOAItemFail() {
        let messageBox = {
            show: true,
            title: "Information",
            className: "info",
            content: "Sorry. Can't puchase Electronic and Grocery items in a same cycle",
            isConfirmation: false,
            callBackFunction: null
        }
        this.props.showMessageBox(messageBox);
    };

    showJKOAShippingMethodFail() {
        let messageBox = {
            show: true,
            title: "Information",
            className: "info",
            content: "Sorry! The Click & Collect facility is not active for mobile phones and electronics at the moment. Please change your shipping method to ‘Delivery’ to continue shopping.",
            isConfirmation: false,
            callBackFunction: null
        }
        this.props.showMessageBox(messageBox);
    };

    decrementProduct(product) {
        DecrementItem(product, () => { })
    };

    showAgeFail() {
        let messageBox = {
            show: true,
            title: "Information",
            className: "info",
            content: "You must be " + this.props.systemConfiguration.legalAgeLimit + " years or older to purchase this product",
            isConfirmation: false,
            callBackFunction: null
        }
        this.props.showMessageBox(messageBox);
    }

    showNotificationBox() {
        if (!this.props.userDetails.isGuest) {
            toast(<div><i className="fas fa-shopping-cart"></i>{"Item successfully added to cart.!"}</div>);
        }
    };

    magnifyProduct(data) {
        if (data.enlargeImageUrl) {
            let productMagnifier = {
                show: true,
                imageUrl: data.enlargeImageUrl
            }
            this.props.showProductMagnifier(productMagnifier);
        }
    }

    gotoDepartment(checkAge, itemCode, itemName) {
        let path = `${this.props.userDetails.isGuest == true ? 'productDetail' : 'productDetailint'}?itemcode=${itemCode}&${itemName.replace(/ /g, "_")}`
        if (this.props.webDataCollection.systemConfiguration.isProductDetailEnabled) {
            if (checkAge) {
                if (this.props.ageVerification.isLegalAge && this.props.ageVerification.attemptedVerification) {
                    window.location.href = path;
                } else if (!this.props.ageVerification.isLegalAge && this.props.ageVerification.attemptedVerification) {
                    this.showAgeFail();
                } else if (!this.props.ageVerification.attemptedVerification) {
                    let ageGate = {
                        show: true,
                        isPage: true,
                        callBackFunction: (response) => {
                            if (response) {
                                this.props.resetAgeGate().then(() => { window.location.href = path; })
                            } else {
                                this.props.resetAgeGate()
                                this.showAgeFail();
                            }
                        }
                    }
                    this.props.showAgeGate(ageGate);
                }
            } else {

                let url = window.location.href;
                let detailUrl = window.location.origin + "/" + path;
                if (url.includes("home")) {
                    window.location.href = path;
                }
                else {
                    window.location.href = detailUrl
                }
            }
        }

    }

    render() {
        const { itemData, showSpecialStyle = true } = this.props;
        const itemPromotion = this.props.promotionItems.find(x => x.itemID === itemData.itemID && x.promotionSubTypeID !== 9);
        return (
            <Col style={{ paddingBottom: "15px" }}>
                <div className="product-card-container" style={showSpecialStyle && itemData.styleBorderColor ? { borderStyle: "solid", borderColor: itemData.styleBorderColor } : {}}>
                    <Row>
                        <Col md="12" className={this.props.webDataCollection.systemConfiguration.isProductDetailEnabled ? "product-card-image-container btn" : "product-card-image-container"} onClick={this.gotoDepartment.bind(this, false, this.props.itemData.itemCode, this.props.itemData.name)} >
                            <img className="img-fluid"
                                onClick={this.props.webDataCollection.systemConfiguration.isProductDetailEnabled ? undefined : this.magnifyProduct.bind(this, itemData)}//</Col>{}//remove when productDetail fucntion adding 
                                src={itemData.imageUrl}
                                onError={(e) => { e.target.onerror = null; e.target.src = "https://essstr.blob.core.windows.net/essimg/Small/Default.jpg" }}></img>
                            {itemPromotion && !itemPromotion.checkPaymentMode ?
                                <div className="product-card-promotion-badge">
                                    {itemPromotion.otherPromotionTypeID === 2 ? <div className="product-card-promotion-badge-nexus"><img className="img-fluid" src={NexusLogo}></img></div> : <div className="product-card-promotion-badge-nexus"><img className="img-fluid" src={KeelsDealsLogo}></img></div>}
                                    <div className="product-card-promotion-badge-single-line">
                                        <div className="product-card-promotion-badge-percentage">
                                            {Math.floor(itemPromotion.discountPercentage)}
                                        </div>
                                        <div>
                                            <div className="product-card-promotion-badge-suffix">%</div>
                                            <div className="product-card-promotion-badge-suffix">Off</div>
                                        </div>
                                    </div>
                                </div>
                                : null}
                            {itemData.isSponsored ?
                                <div className="product-card-sponsor-badge">
                                    <div className="product-card-sponsor-badge-single-line">
                                        <div className="">Sponsored</div>
                                    </div>
                                </div>
                                : null}

                            {itemData.isFeatured && !this.props.webDataCollection.systemConfiguration.isProductDetailEnabled ?
                                <div className="product-card-feature-badge">
                                    <div className="product-card-sponsor-badge-single-line">
                                        <div className="">Featured</div>
                                    </div>
                                </div>
                                : null}

                            {showSpecialStyle && itemData.styleImageURL ?
                                <div className="product-card-special-style-image">
                                    <img className="img-fluid" src={itemData.styleImageURL}></img>
                                </div>
                                : null}

                            {showSpecialStyle && itemData.styleImageURL ?
                                <div className="product-card-special-style-image">
                                    <img className="img-fluid" src={itemData.styleImageURL}></img>
                                </div>
                                : null}
                            {itemData.isFeatured && this.props.webDataCollection.systemConfiguration.isProductDetailEnabled ?
                                <div className="product-card-feature-flag">
                                    <div className="product-card-feature-flag-percentage">
                                        Featured
                                    </div>
                                </div>
                                : null}
                            {itemData.hasMoreDeals === 1 && this.props.webDataCollection.systemConfiguration.isProductDetailEnabled ? <div className="product-card-offer-badge">
                                <div className="product-card-offer-badge-percentage">
                                    <div>
                                        <div style={{ fontSize: "14px" }}>More Deals</div>
                                    </div>
                                </div>
                            </div> : null}

                        </Col>
                        <Col md="12" className={this.props.webDataCollection.systemConfiguration.isProductDetailEnabled ? "product-card-name btn" : "product-card-name"} onClick={this.gotoDepartment.bind(this, false, this.props.itemData.itemCode, this.props.itemData.name)} >
                            {itemData.name}
                        </Col>
                        <Col md="12" className={this.props.webDataCollection.systemConfiguration.isProductDetailEnabled ? "product-card-price-container btn" : "product-card-price-container"} onClick={this.gotoDepartment.bind(this, false, this.props.itemData.itemCode, this.props.itemData.name)} >
                            {itemData.promotionDiscountValue > 0 && itemPromotion && !itemPromotion.checkPaymentMode ? <div className="product-card-original-price">{"Rs " + toCurrency(itemData.amount)}</div> : null}
                            {itemPromotion && !itemPromotion.checkPaymentMode ? <div className="product-card-final-price">{"Rs " + toCurrency(Math.floor(itemData.amount - itemData.promotionDiscountValue)) + " / " + (itemData.uom === "NO" ? "Unit" : itemData.uom)}</div> : <div className="product-card-final-price">{"Rs " + toCurrency(itemData.amount)}</div>}
                        </Col>

                        <Col md="12" className="product-card-button-container">
                            {this.props.itemCart.find(x => x.itemID === itemData.itemID) ? <ButtonGroup className="product-card-button-quantity-selector w-100">
                                <Button className="product-card-button-quantity-decrementor" onClick={this.decrementProduct.bind(this, itemData)}><i className="fas fa-minus"></i></Button>
                                <Button className="product-card-button-quantity-display">{this.props.itemCart.find(x => x.itemID === itemData.itemID).quantity}</Button>
                                <Button className="product-card-button-quantity-incrementor" onClick={this.incrementProduct.bind(this, itemData)}><i className="fas fa-plus"></i></Button>
                            </ButtonGroup>
                                :
                                itemData.stockInHand === 0 || itemData.stockInHand < itemData.minQty ?
                                    <Button block className="product-card-button-add" id="add_to_cartId" disabled={true} >Out of Stock</Button>
                                    :
                                    <Button block className="product-card-button-add" onClick={() => { this.addProduct(itemData) }}><i className="fas fa-shopping-cart"></i>Add to Cart</Button>}
                        </Col>
                    </Row>
                </div>
            </Col>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductCard);